import { createStore, combineReducers, applyMiddleware } from 'redux'
import { connectRouter, routerMiddleware } from 'connected-react-router'
import { createLogger } from 'redux-logger'
import thunk from 'redux-thunk'

import history from './history'
import reducers from './reducers'
import { IS_PRD } from './utils/apiConstants'
import { CENTRIFUGE_UPDATE_AUCTION_TIME, TICK_AUCTION_TIMER } from './actions/types'

const middlewareHistory = routerMiddleware(history)

const rootReducer = combineReducers({
  ...reducers,
  router: connectRouter(history),
})

const applyM = IS_PRD
  ? applyMiddleware(middlewareHistory, thunk)
  : applyMiddleware(
    middlewareHistory,
    thunk,
    createLogger({
      predicate: (getState, action) => {
        if (action && action.type) {
          return (
            action.type !== CENTRIFUGE_UPDATE_AUCTION_TIME && action.type !== TICK_AUCTION_TIMER
          )
        }
        return false
      },
    }),
  )

const store = createStore(rootReducer, applyM)

export default store
